/**
 * @generated SignedSource<<074c0ea46e352542df0b677461db4e93>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetNoteCameraMode_widgetNotePage$data = {
  readonly " $fragmentSpreads": FragmentRefs<"WidgetNoteText_page">;
  readonly " $fragmentType": "WidgetNoteCameraMode_widgetNotePage";
};
export type WidgetNoteCameraMode_widgetNotePage$key = {
  readonly " $data"?: WidgetNoteCameraMode_widgetNotePage$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetNoteCameraMode_widgetNotePage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetNoteCameraMode_widgetNotePage",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetNoteText_page"
    }
  ],
  "type": "WidgetNotePage",
  "abstractKey": null
};

(node as any).hash = "b0952357119bdf6d3ccce7819f956626";

export default node;
